import CartPreview from '@app/Cart/Preview'
import GiftVariants from '@app/Cart/GiftVariants'
import StockChecker from '@app/Cart/StockChecker'
import Promocode from '@app/Cart/Promocode'
import ProductBaseView from '@app/Cart/Variants/Base'
import CartCampaignUi from '@app/Cart/CampaignUi'
import CartPage from '@app/Cart/CartPage.vue'
import SetView from '@app/Cart/SetView.vue'
import SetViewDetailed from '@app/Cart/SetViewDetailed.vue'

export default function install(Vue) {
  Vue.component(SetView.name, SetView)
  Vue.component(CartPage.name, CartPage)
  Vue.component(CartPreview.name, CartPreview)
  Vue.component(GiftVariants.name, GiftVariants)
  Vue.component(StockChecker.name, StockChecker)
  Vue.component(Promocode.name, Promocode)
  Vue.component(ProductBaseView.name, ProductBaseView)
  Vue.component(CartCampaignUi.name, CartCampaignUi)
  Vue.component(SetViewDetailed.name, SetViewDetailed)
}
